// Copy for the קטגוריות confirmations.
//
// Deliberately NOT reusing deleteClassificationDialog: that copy is about PRODUCTS
// moving to "לא מסווג", which is simply untrue here. A קטגוריה owns no
// products — it owns rules pointing at classifications and suppliers. Deleting one
// removes the rules and the target; every product, classification and supplier is
// exactly where it was.
//
// Getting that wrong would be worse than vague: a user told their products are
// about to move will not press the button.

/**
 * Deleting a קטגוריה.
 *
 * Names what actually goes (the rules, the target) and what does not (anything
 * anyone tagged), then says where the money lands instead — because that is the
 * question the number on the screen behind the dialog is about to answer
 * differently.
 *
 * Revenue is NOT in that list any more. It used to be: each category carried its
 * own revenue rows and deleting one destroyed data the user had typed. Revenue
 * now belongs to the restaurant and survives any category coming or going, so
 * this dialog no longer has to warn about it.
 */
export function deleteCategoryLineDialog({ name, classificationCount = 0, supplierCount = 0 }) {
  const rules = [];
  if (classificationCount > 0) {
    rules.push(classificationCount === 1 ? 'סיווג פריט אחת' : `${classificationCount} סיווג פריטים`);
  }
  if (supplierCount > 0) {
    rules.push(supplierCount === 1 ? 'ספק אחד' : `${supplierCount} ספקים`);
  }

  const body = [];
  if (rules.length > 0) {
    body.push(
      `${rules.join(' ו-')} מפנים כרגע לקטגוריה הזו. השיוך יוסר, והרכש שלהם יחזור להיות ` +
      'ללא קטגוריה — עד שתשייכו אותו לקטגוריה אחרת.',
    );
  } else {
    body.push('לא מפנים לקטגוריה הזו סיווגים או ספקים, ולכן המחיקה לא משנה שום שיוך.');
  }

  // The reassurance is a main clause, not a parenthetical: this is the fear
  // that stops the click.
  body.push('הסיווגים, הספקים והמוצרים עצמם לא משתנים — נמחקים רק הקטגוריה והיעד שנקבע לה.');

  return {
    title: `מחיקת הקטגוריה "${name}"`,
    body,
    confirmLabel: 'מחק את הקטגוריה',
    cancelLabel: 'השאר את הקטגוריה',
    tone: 'danger',
  };
}
